var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('user-core-drawer'),_c('user-core-view'),_c('vue-confirm-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }